import script from "./ModelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelModal.vue?vue&type=script&setup=true&lang=js"

import "./ModelModal.vue?vue&type=style&index=0&id=1e24c8f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e24c8f4"]])

export default __exports__